<br/>
<h1 style="margin-left: 31px;
font-size: 24px;
margin-top: 8px;
font-weight: bolder;">Import Materials</h1>
<br>
<div class="UploadLimit" *ngIf="!(this.data.length >= 500)">
	<div class="iconClass">
		<img src="../../../../assets/images/Iconinfo.png"/>
	</div>
	<div class="textClass">
		<span>Please note that the limit of items is 500</span>
	</div>
</div>
<h4 style="margin-left: 31px;
font-size: 16px;
margin-top: 18px;
font-weight: bolder;">Upload Files</h4>
<!-- <br> -->
<h5 style="margin-left: 31px;color:grey" disabled="true1qa">XLSX, XLS. Max size of 50k.</h5>

<input  type="file" (change)="onFileChange($event)" multiple="false" style="
height: 40px; margin-left: 24px;" />
<!-- <table class="sjs-table">
	<tbody>
		<span *ngIf="fileSize<=50000">
			<tr *ngFor="let row of data">
				<td *ngFor="let val of row">	
				</td>
			</tr>
			<span style="margin-left: 33px;" *ngIf="data!=null">{{fileNameofXls}}
				<div>
					<hr style="font-size: 30px;">
					<div style="color:green;margin-left:33px">Successfully Uploaded</div>
				</div>
			</span>
		</span>
		<span *ngIf="fileSize>=50000"></span>
	</tbody>
</table> -->
<div class="successUpload" *ngIf="fileSize<=50000 && data!=null">
	<div class="xlsIcon">
		<img src="../../../../assets/images/xls.png"/>
		&nbsp;<span style="font-weight: 400;font-size: 14px;line-height: 20px;color: #53565A;">{{fileNameofXls}}</span>
	</div>
	<div class="uploadBar">
		<span style="font-weight: 400;font-size: 12px;line-height:16px;color:#26890D">Successfully Uploaded</span>
	</div>
</div>
<br/>
<a style="margin-left: 31px;
text-decoration: underline;
color: #00a3e0;font-size: 15px; cursor: pointer;" (click)="export()">Download Template</a>

<h5 style="margin-left: 31px;color:grey;margin-top: 6px;" disabled="true">Get XLSX template to fill in for import.</h5>

<br/>
	
	
<button type="button" (click)="PostData()" [ngClass]="{'activeBtn':this.data.length <= 500,'inactiveBtn':this.data.length > 500 || this.data.length == 0}" [disabled]="this.data.length > 500 || this.data.length == 0"><span>Import</span></button>
<button type="button" (click)="Cancel()" style="background: #53565A;float:right;margin-right:3px;margin-bottom: 15px;color:#fff;"><span>Cancel</span></button>
	